import React from 'react';
import { findIndex, filter } from 'lodash';
import { ChromePicker } from 'react-color';

import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row
} from 'react-bootstrap';


// import Tooltip from '../../../commonComponents/Tooltip';
import PagerUd from '../../../commonComponents/PagerUd';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import { DataListWrapper } from '../../../commonComponents/DataTable/DataTablePs';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
import RequiredMark from '../../../commonComponents/RequiredMark';

import custJqAjax from '../../../commonJS/custJqAjax';
import autoFill from '../../../commonJS/autoFill';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { textInputOnChange, dropDownOnChange } from '../../../commonJS/onFormChanges';

import getAdminItemStateName from './getAdminItemStateName';

export default class SimpleModalCt extends React.Component {
  constructor(props) {
    super(props);

    this.customization = {
      // id key state定義要和api id key相同 ===
      itemApiIdKeyName: '',
      defaultState: {},
      // ===
      // 用於處理 update or delete api id key 名稱與 get 不一致問題…依 api 定義 ===
      updateOrDeleteIdKeyName: '',
      // ===
      // 不含id key。state定義和api key name要相同。 ===
      postFormKeys: [],
      // 多國語言才會用到，要和postFormKeys順序相同
      langCodePool: [],
      // ===
      dataWrapperStateName: '',
      apiAdaptedDataStateName: '',
      loadApi: '',
      saveApi: '',
      deleteApi: '',
      // 基本檔維護大部分不需要api load，只需要從table data取出即可
      loadSuccessCb: 'cb',
      saveSuccessCb: 'cb',
      // 必填欄位檢查用
      saveBtnValidationKeys: [],
      // 表單元件參數定義
      formCompos: [
        {
          // 表單元件類別，有textInput與dropDown兩種
          type: '',
          // 標題
          label: '',
          // 寬度
          sm: 12,
          required: true,
          validation: true,
          // 是否可互動
          disabled: true,
          // 對應的stateName
          stateName: '',
          // 若為下拉選單，來源清單propsName
          optionsPropsKeyName: '',
          // for default focus
          id: 'parentRoleIdDropDown',
          // for autofill
          autoFillEnable: false
        }
      ],
      // 特殊用途函式
      custFunc: 'func',
      defaultFocusField: ''
    };

    switch (props.activeAdminItem) {
      case 'user-role':
        // 共用modal不同點定義
        this.customization = {
          // id key state定義要和api id key相同
          itemApiIdKeyName: 'sub_role',
          defaultState: { sub_role: '', main_role: '', department_id: '', role_name: '' },
          updateOrDeleteIdKeyName: 'sub_role',
          dataWrapperStateName: 'userRoleSortedData',
          loadApi: '',
          saveApi: 'W_Role_',
          deleteApi: 'W_Role_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              department_id: selectedItem.department_id,
              role_name: selectedItem.role_name,
              main_role: selectedItem.main_role,
              sub_role: selectedItem.sub_role
            });
          },
          postFormKeys: ['main_role', 'department_id', 'role_name'],
          saveBtnValidationKeys: ['main_role', 'department_id', 'role_name'],
          formCompos: [
            {
              type: 'dropDown',
              label: '父階角色',
              sm: 12,
              required: true,
              stateName: 'main_role',
              validation: true,
              optionsPropsKeyName: 'optsUserRole',
              id: 'parentRoleIdDropDown'
            },
            {
              type: 'textInput',
              label: '角色名稱',
              sm: 12,
              required: true,
              stateName: 'role_name',
              validation: true
            },
            {
              type: 'dropDown',
              label: '群組名稱',
              sm: 12,
              required: true,
              stateName: 'department_id',
              validation: true,
              optionsPropsKeyName: 'optsUserGroup'
            }
          ],
          defaultFocusField: 'parentRoleIdDropDown'
        };
        break;
      case 'user-group':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '', color_code: '#E42CD4' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name', 'color_code'],
          dataWrapperStateName: 'userGroupSortedData',
          loadApi: '',
          saveApi: 'W_UserGroup_',
          deleteApi: 'W_UserGroup_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              color_code: selectedItem.color_code,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '群組',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            },
            {
              type: 'colorPicker',
              label: '群組顏色',
              sm: 12,
              required: true,
              stateName: 'color_code',
              validation: false
            }
          ],
          custFunc: (color) => {
            this.setState({ color_code: color.hex });
          },
          defaultFocusField: 'name'
        };
        break;
      case 'supervisor-evaluation':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '', remark: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name', 'remark'],
          dataWrapperStateName: 'supervisorEvaluationSortedData',
          loadApi: '',
          saveApi: 'W_Supervisor_Review_Type_',
          deleteApi: 'W_Supervisor_Review_Type_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              remark: selectedItem.remark,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '評核等級',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            },
            {
              type: 'textInput',
              label: '評語',
              sm: 12,
              required: false,
              stateName: 'remark',
              validation: false
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'repair-area':
        this.customization = {
          itemApiIdKeyName: 'area_type_id',
          defaultState: { area_type_id: '', area_type_name_tw: '', area_type_name_en: '', area_type_name_cn: '', area_type_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['area_type_name_tw', 'area_type_name_en', 'area_type_name_cn', 'area_type_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-area').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-area').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Area_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Area_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { area_type_id: selectedItem.area_type_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              area_type_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].area_type_name,
              area_type_name_en: filter(itemCollection, { lang_code: 'en' })[0].area_type_name,
              area_type_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].area_type_name,
              area_type_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].area_type_name,
              area_type_id: selectedItem.area_type_id
            });
          },
          saveBtnValidationKeys: ['area_type_name_tw', 'area_type_name_en', 'area_type_name_cn', 'area_type_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'area_type_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'area_type_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'area_type_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'area_type_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'area_type_name_tw'
        };
        break;
      case 'repair-form-type':
        this.customization = {
          itemApiIdKeyName: 'type_id',
          defaultState: { type_id: '', type_name_tw: '', type_name_en: '', type_name_cn: '', type_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['type_name_tw', 'type_name_en', 'type_name_cn', 'type_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-form-type').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-form-type').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { type_id: selectedItem.type_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              type_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].type_name,
              type_name_en: filter(itemCollection, { lang_code: 'en' })[0].type_name,
              type_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].type_name,
              type_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].type_name,
              type_id: selectedItem.type_id
            });
          },
          saveBtnValidationKeys: ['type_name_tw', 'type_name_en', 'type_name_cn', 'type_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'type_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'type_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'type_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'type_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'type_name_tw'
        };
        break;
      case 'repair-warranty-type':
        this.customization = {
          itemApiIdKeyName: 'warranty_type_id',
          defaultState: { warranty_type_id: '', warranty_type_name_tw: '', warranty_type_name_en: '', warranty_type_name_cn: '', warranty_type_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['warranty_type_name_tw', 'warranty_type_name_en', 'warranty_type_name_cn', 'warranty_type_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-warranty-type').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-warranty-type').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Warranty_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Warranty_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { warranty_type_id: selectedItem.warranty_type_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              warranty_type_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].warranty_type_name,
              warranty_type_name_en: filter(itemCollection, { lang_code: 'en' })[0].warranty_type_name,
              warranty_type_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].warranty_type_name,
              warranty_type_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].warranty_type_name,
              warranty_type_id: selectedItem.warranty_type_id
            });
          },
          saveBtnValidationKeys: ['warranty_type_name_tw', 'warranty_type_name_en', 'warranty_type_name_cn', 'warranty_type_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'warranty_type_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'warranty_type_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'warranty_type_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'warranty_type_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'warranty_type_name_tw'
        };
        break;
      case 'repair-product-from':
        this.customization = {
          itemApiIdKeyName: 'from_id',
          defaultState: { from_id: '', from_name_tw: '', from_name_en: '', from_name_cn: '', from_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['from_name_tw', 'from_name_en', 'from_name_cn', 'from_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-product-from').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-product-from').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_From_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_From_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { from_id: selectedItem.from_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              from_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].from_name,
              from_name_en: filter(itemCollection, { lang_code: 'en' })[0].from_name,
              from_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].from_name,
              from_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].from_name,
              from_id: selectedItem.from_id
            });
          },
          saveBtnValidationKeys: ['from_name_tw', 'from_name_en', 'from_name_cn', 'from_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'from_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'from_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'from_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'from_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'from_name_tw'
        };
        break;
      case 'repair-service-type':
        this.customization = {
          itemApiIdKeyName: 'service_type_id',
          defaultState: { service_type_id: '', service_type_name_tw: '', service_type_name_en: '', service_type_name_cn: '', service_type_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['service_type_name_tw', 'service_type_name_en', 'service_type_name_cn', 'service_type_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-service-type').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-service-type').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Service_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Service_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { service_type_id: selectedItem.service_type_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              service_type_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].service_type_name,
              service_type_name_en: filter(itemCollection, { lang_code: 'en' })[0].service_type_name,
              service_type_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].service_type_name,
              service_type_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].service_type_name,
              service_type_id: selectedItem.service_type_id
            });
          },
          saveBtnValidationKeys: ['service_type_name_tw', 'service_type_name_en', 'service_type_name_cn', 'service_type_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'service_type_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'service_type_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'service_type_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'service_type_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'service_type_name_tw'
        };
        break;
      case 'repair-owner-judgement':
        this.customization = {
          itemApiIdKeyName: 'judge_id',
          defaultState: { judge_id: '', judge_name_tw: '', judge_name_en: '', judge_name_cn: '', judge_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['judge_name_tw', 'judge_name_en', 'judge_name_cn', 'judge_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-owner-judgement').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-owner-judgement').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Judge_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Judge_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { judge_id: selectedItem.judge_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              judge_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].judge_name,
              judge_name_en: filter(itemCollection, { lang_code: 'en' })[0].judge_name,
              judge_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].judge_name,
              judge_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].judge_name,
              judge_id: selectedItem.judge_id
            });
          },
          saveBtnValidationKeys: ['judge_name_tw', 'judge_name_en', 'judge_name_cn', 'judge_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'judge_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'judge_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'judge_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'judge_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'judge_name_tw'
        };
        break;
      case 'repair-currency':
        this.customization = {
          itemApiIdKeyName: 'currency_id',
          defaultState: { currency_id: '', currency_name_tw: '', currency_name_en: '', currency_name_cn: '', currency_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['currency_name_tw', 'currency_name_en', 'currency_name_cn', 'currency_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-currency').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-currency').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Currency_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Currency_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { currency_id: selectedItem.currency_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              currency_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].currency_name,
              currency_name_en: filter(itemCollection, { lang_code: 'en' })[0].currency_name,
              currency_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].currency_name,
              currency_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].currency_name,
              currency_id: selectedItem.currency_id
            });
          },
          saveBtnValidationKeys: ['currency_name_tw', 'currency_name_en', 'currency_name_cn', 'currency_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'currency_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'currency_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'currency_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'currency_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'currency_name_tw'
        };
        break;
      case 'repair-service-satisfaction':
        this.customization = {
          itemApiIdKeyName: 'satisfaction_id',
          defaultState: { satisfaction_id: '', satisfaction_name_tw: '', satisfaction_name_en: '', satisfaction_name_cn: '', satisfaction_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['satisfaction_name_tw', 'satisfaction_name_en', 'satisfaction_name_cn', 'satisfaction_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-service-satisfaction').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-service-satisfaction').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Satisfaction_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Satisfaction_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { satisfaction_id: selectedItem.satisfaction_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              satisfaction_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].satisfaction_name,
              satisfaction_name_en: filter(itemCollection, { lang_code: 'en' })[0].satisfaction_name,
              satisfaction_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].satisfaction_name,
              satisfaction_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].satisfaction_name,
              satisfaction_id: selectedItem.satisfaction_id
            });
          },
          saveBtnValidationKeys: ['satisfaction_name_tw', 'satisfaction_name_en', 'satisfaction_name_cn', 'satisfaction_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'satisfaction_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'satisfaction_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'satisfaction_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'satisfaction_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'satisfaction_name_tw'
        };
        break;
      case 'repair-issue-type':
        this.customization = {
          itemApiIdKeyName: 'issue_type_id',
          defaultState: { issue_type_id: '', issue_type_name_tw: '', issue_type_name_en: '', issue_type_name_cn: '', issue_type_name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['issue_type_name_tw', 'issue_type_name_en', 'issue_type_name_cn', 'issue_type_name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-issue-type').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-issue-type').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Issue_Type_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Issue_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { issue_type_id: selectedItem.issue_type_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              issue_type_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].issue_type_name,
              issue_type_name_en: filter(itemCollection, { lang_code: 'en' })[0].issue_type_name,
              issue_type_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].issue_type_name,
              issue_type_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].issue_type_name,
              issue_type_id: selectedItem.issue_type_id
            });
          },
          saveBtnValidationKeys: ['issue_type_name_tw', 'issue_type_name_en', 'issue_type_name_cn', 'issue_type_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'issue_type_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'issue_type_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'issue_type_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'issue_type_name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'issue_type_name_tw'
        };
        break;
      case 'repair-status':
        this.customization = {
          itemApiIdKeyName: 'status_id',
          defaultState: { status_id: '', status_name_tw: '', status_name_en: '', status_name_cn: '', status_name_ja: '', color_code: '#E42CD4' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['status_name_tw', 'status_name_en', 'status_name_cn', 'status_name_ja', 'color_code'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('repair-status').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('repair-status').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_ServiceSky_RepairSky_Status_Lang_',
          deleteApi: 'W_ServiceSky_RepairSky_Status_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { status_id: selectedItem.status_id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              status_name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].status_name,
              status_name_en: filter(itemCollection, { lang_code: 'en' })[0].status_name,
              status_name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].status_name,
              status_name_ja: filter(itemCollection, { lang_code: 'ja' })[0].status_name,
              status_id: selectedItem.status_id,
              color_code: selectedItem.color_code
            });
          },
          saveBtnValidationKeys: ['status_name_tw', 'status_name_en', 'status_name_cn', 'status_name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'status_name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'status_name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'status_name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'status_name_ja',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'colorPicker',
              label: '狀態顏色',
              sm: 12,
              required: true,
              stateName: 'color_code',
              validation: false
            }
          ],
          custFunc: (color) => {
            this.setState({ color_code: color.hex });
          },
          defaultFocusField: 'status_name_tw'
        };
        break;
      case 'system-parameter-setting':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', item: '', value: '', remark: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['item', 'value', 'remark'],
          dataWrapperStateName: 'systemParameterSettingSortedData',
          loadApi: '',
          saveApi: 'W_System_Environment_',
          deleteApi: 'W_System_Environment_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              item: selectedItem.item,
              value: selectedItem.value,
              remark: selectedItem.remark,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['item', 'value'],
          formCompos: [
            {
              type: 'textInput',
              label: '參數名稱',
              sm: 12,
              required: true,
              stateName: 'item',
              validation: true
            },
            {
              type: 'textInput',
              label: '設定值',
              sm: 12,
              required: true,
              stateName: 'value',
              validation: true
            },
            {
              type: 'textInput',
              label: '備註',
              sm: 12,
              required: false,
              stateName: 'remark',
              validation: false
            }
          ],
          defaultFocusField: 'item'
        };
        break;
      case 'company-zone':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'companyZoneSortedData',
          loadApi: '',
          saveApi: 'W_Zone_',
          deleteApi: 'W_Zone_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '區域',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'company-industry':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'companyIndustrySortedData',
          loadApi: '',
          saveApi: 'W_Industry_',
          deleteApi: 'W_Industry_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '行業別',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'company-trade':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'companyTradeSortedData',
          loadApi: '',
          saveApi: 'W_Trade_',
          deleteApi: 'W_Trade_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '產業',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'work-nature':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'workNatureSortedData',
          loadApi: '',
          saveApi: 'W_WorkNature_',
          deleteApi: 'W_WorkNature_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '工作性質',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'work-progress':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'workProgressSortedData',
          loadApi: '',
          saveApi: 'W_ProgressStatus_',
          deleteApi: 'W_ProgressStatus_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '工作進度',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'project-progress':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'projectProgressSortedData',
          loadApi: '',
          saveApi: 'W_ProjectProgress_',
          deleteApi: 'W_ProjectProgress_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '專案狀態',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'media-cloud-file-attribute':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name'],
          dataWrapperStateName: 'mediaCloudFileAttributeSortedData',
          loadApi: '',
          saveApi: 'W_FileProperty_',
          deleteApi: 'W_FileProperty_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'textInput',
              label: '檔案屬性',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'name'
        };
        break;
      case 'media-cloud-file-attribute-value':
        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name: '', fileproperty_id: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name', 'fileproperty_id'],
          dataWrapperStateName: 'mediaCloudFileAttributeValueSortedData',
          loadApi: '',
          saveApi: 'W_FilePropertyValue_',
          deleteApi: 'W_FilePropertyValue_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck());

            this.setState({
              name: selectedItem.name,
              fileproperty_id: selectedItem.fileproperty_id,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name'],
          formCompos: [
            {
              type: 'dropDown',
              label: '檔案屬性',
              sm: 12,
              required: true,
              stateName: 'fileproperty_id',
              validation: true,
              optionsPropsKeyName: 'optsFileProperty',
              id: 'filePropertyIdDropDown'
            },
            {
              type: 'textInput',
              label: '檔案屬性值',
              sm: 12,
              required: true,
              stateName: 'name',
              validation: true
            }
          ],
          defaultFocusField: 'filePropertyIdDropDown'
        };
        break;
      case 'news-type':

        this.customization = {
          itemApiIdKeyName: 'id',
          defaultState: { id: '', name_tw: '', name_en: '', name_cn: '', name_ja: '' },
          updateOrDeleteIdKeyName: 'id',
          postFormKeys: ['name_tw', 'name_en', 'name_cn', 'name_ja'],
          langCodePool: ['zh-tw', 'en', 'zh-cn', 'ja'],
          dataWrapperStateName: getAdminItemStateName('news-type').dataWrapperStateName,
          apiAdaptedDataStateName: getAdminItemStateName('news-type').apiAdaptedDataStateName,
          loadApi: '',
          saveApi: 'W_SaleSky_News_Type_Lang_',
          deleteApi: 'W_SaleSky_News_Type_Lang_Delete.php',
          loadSuccessCb: () => {
            // 基本檔維護大部分不需要api load，只需要從table data取出即可
            const selectedItem = this.props.sortedData.getObjectAt(this.handlers.rowIndexCheck()),
              apiAdaptedData = this.props.apiAdaptedData,
              // 第一階段過濾
              itemCollection = filter(apiAdaptedData, { id: selectedItem.id });

            this.setState({
              // 使用第一階段過濾結果進行第二階段過濾
              name_tw: filter(itemCollection, { lang_code: 'zh-tw' })[0].name,
              name_en: filter(itemCollection, { lang_code: 'en' })[0].name,
              name_cn: filter(itemCollection, { lang_code: 'zh-cn' })[0].name,
              name_ja: filter(itemCollection, { lang_code: 'ja' })[0].name,
              id: selectedItem.id
            });
          },
          saveBtnValidationKeys: ['name_tw', 'name_en', 'name_cn', 'name_ja'],
          formCompos: [
            {
              type: 'textInput',
              label: '繁體中文',
              sm: 6,
              required: true,
              stateName: 'name_tw',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '英文',
              sm: 6,
              required: true,
              stateName: 'name_en',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '簡體中文',
              sm: 6,
              required: true,
              stateName: 'name_cn',
              validation: true,
              autoFillEnable: true
            },
            {
              type: 'textInput',
              label: '日文',
              sm: 6,
              required: true,
              stateName: 'name_ja',
              validation: true,
              autoFillEnable: true
            }
          ],
          defaultFocusField: 'name_tw'
        };
        break;
      default:

    };

    this.handlers = {
      textInputOnChange: e => {
        textInputOnChange(e, this);
      },
      dropDownOnChange: (selection, stateName) => {
        const obj = dropDownOnChange(selection, stateName);

        this.setState(obj);
      },
      onInputFocus: e => {
        autoFill(e, this);
      },
      saveItem: isUpdate => {
        const state = this.state,
          props = this.props,
          updateOrDeleteIdKeyName = this.customization.updateOrDeleteIdKeyName,
          itemApiIdKeyName = this.customization.itemApiIdKeyName,
          postFormKeys = this.customization.postFormKeys;

        let formData = new FormData(),
          jsonContent = {};
        // loop for form appending

        switch (this.props.activeAdminItem) {
          case 'repair-area':
          case 'repair-form-type':
          case 'repair-warranty-type':
          case 'repair-product-from':
          case 'repair-service-type':
          case 'repair-owner-judgement':
          case 'repair-currency':
          case 'repair-service-satisfaction':
          case 'repair-issue-type':
            for (let i = postFormKeys.length - 1; i >= 0; i--) {
              const keyName = postFormKeys[i];

              jsonContent[this.customization.langCodePool[i]] = state[keyName];
            }

            jsonContent = JSON.stringify(jsonContent);
            formData.append('jsonarray', jsonContent);

            break;
          case 'news-type':
            for (let i = postFormKeys.length - 1; i >= 0; i--) {
              const keyName = postFormKeys[i];

              formData.append(keyName, state[keyName]);
            }

            break;
          case 'repair-status':
            for (let i = postFormKeys.length - 1; i >= 0; i--) {
              const keyName = postFormKeys[i];
              if (keyName === 'color_code') {
                // 修改格式配合 api 資料結構
                // formData.append('color_code', state[keyName]);
              } else {
                jsonContent[this.customization.langCodePool[i]] = { status_name: state[keyName], color_code: state.color_code };
              }
            }

            jsonContent = JSON.stringify(jsonContent);
            formData.append('jsonarray', jsonContent);

            break;
          default:

            for (let i = postFormKeys.length - 1; i >= 0; i--) {
              const keyName = postFormKeys[i];
              formData.append(keyName, state[keyName]);
            }
        }

        if (isUpdate) {
          formData.append(updateOrDeleteIdKeyName, state[itemApiIdKeyName]);
        }

        custJqAjax({
          type: 'POST',
          url: `/api/${this.customization.saveApi}${isUpdate ? 'Update' : 'Post'}.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            let data;
            // 百變api特別處理
            switch (this.props.activeAdminItem) {
              case 'repair-area':
              case 'repair-status':
              case 'repair-form-type':
              case 'repair-warranty-type':
              case 'repair-product-from':
              case 'repair-service-type':
              case 'repair-owner-judgement':
              case 'repair-currency':
              case 'repair-service-satisfaction':
              case 'repair-issue-type':
                data = res.result;
                break;
              case 'news-type':
                data = [
                  { id: res.result.id, name: res.result.name_tw, lang_code: 'zh-tw' },
                  { id: res.result.id, name: res.result.name_en, lang_code: 'en' },
                  { id: res.result.id, name: res.result.name_cn, lang_code: 'zh-cn' },
                  { id: res.result.id, name: res.result.name_ja, lang_code: 'ja' }
                ];
                break;
              default:
                data = res.result[0] || res.result;
            };


            this.handlers.onItemModified(data, isUpdate ? 'update' : 'create');

            props.closeModal();

            // 更新搜尋結果
            props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
          }
        });
      },
      deleteItem: () => {
        const formData = new FormData(),
          updateOrDeleteIdKeyName = this.customization.updateOrDeleteIdKeyName,
          itemApiIdKeyName = this.customization.itemApiIdKeyName,
          id = this.props.selectedItemId;

        formData.append(updateOrDeleteIdKeyName, id);

        custJqAjax({
          type: 'POST',
          url: `/api/${this.customization.deleteApi}`,
          data: formData,
          processData: false,
          contentType: false,
          success: data => {
            const itemInd = findIndex(this.props.sortedData._data, { [itemApiIdKeyName]: id });

            this.handlers.onItemModified({ itemInd }, 'delete');
            this.props.closeModal({ isDeletion: true });
            this.props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
          }
        });
      },
      onItemModified: (data, mode) => {
        // 更新sortedData
        const itemApiIdKeyName = this.customization.itemApiIdKeyName,
          dataWrapperStateName = this.customization.dataWrapperStateName,
          apiAdaptedDataStateName = this.customization.apiAdaptedDataStateName;

        let sortedData = this.props.sortedData,
          apiAdaptedData = (this.props.apiAdaptedData ? this.props.apiAdaptedData.slice() : []),
          // 判斷是否為 apiAdaptedData
          dataIsArray = false,
          extraStates = [],
          extraNewValues = [],
          itemId, newItem,
          // local cache 更新目標
          localCacheName, localCacheData;

        switch (this.props.activeAdminItem) {
          case 'repair-area':
          case 'repair-status':
          case 'repair-form-type':
          case 'repair-warranty-type':
          case 'repair-product-from':
          case 'repair-service-type':
          case 'repair-owner-judgement':
          case 'repair-currency':
          case 'repair-service-satisfaction':
          case 'repair-issue-type':
          case 'news-type':
            newItem = {
              ...filter(data, { lang_code: 'zh-tw' })[0]
            };

            itemId = newItem[itemApiIdKeyName];
            dataIsArray = true;
            extraStates.push(apiAdaptedDataStateName);
            extraNewValues.push(apiAdaptedData);

            break;
          default:
            itemId = data[itemApiIdKeyName];
            newItem = {
              ...data
            };

            switch (this.props.activeAdminItem) {
              case 'work-nature':
                localCacheName = 'optsWorkNature';
                localCacheData = this.props.optsWorkNature;
                break;
              case 'work-progress':
                localCacheName = 'optsProgressStatus';
                localCacheData = this.props.optsProgressStatus;
                break;
              case 'project-progress':
                localCacheName = 'optsProjectProgress';
                localCacheData = this.props.optsProjectProgress;
                break;
              default:

            }

        }

        if (mode === "create") {
          const len = sortedData._data.length;
          sortedData._data.push(newItem);
          if (dataIsArray) {
            // 順序對此不重要
            apiAdaptedData.push(...data);
          }

          if (localCacheName) {
            localCacheData.push({ value: itemId, label: newItem.name });
          }

          // 新增的資料預設排在最前面
          sortedData._indexMap.unshift(len);
        } else if (mode === "update") {
          let updateInd = findIndex(sortedData._data, { [itemApiIdKeyName]: itemId });
          sortedData._data[updateInd] = newItem;

          if (dataIsArray) {
            for (let i = data.length - 1; i >= 0; i--) {
              const ind = findIndex(apiAdaptedData, { [itemApiIdKeyName]: itemId, lang_code: data[i].lang_code });
              apiAdaptedData[ind] = data[i];
            }
          }

          if (localCacheName) {
            const ind = findIndex(localCacheData, { value: itemId });
            localCacheData[ind] = { value: itemId, label: newItem.name };
          }

        } else if (mode === "delete") {
          const id = this.props.selectedItemId;
          if (dataIsArray) {
            const dataCollection = filter(apiAdaptedData, { [itemApiIdKeyName]: id }),
              len = dataCollection.length;

            for (let i = 0; i < len; i++) {
              const ind = findIndex(apiAdaptedData, { [itemApiIdKeyName]: id, lang_code: dataCollection[i].lang_code });
              apiAdaptedData.splice(ind, 1);
            }
          }

          if (localCacheName) {
            const ind = findIndex(localCacheData, { value: id });
            localCacheData.splice(ind, 1);
          }

          // 從indexMap中移除索引即可，不需從_data中移除資料
          // 確保為完整資料map而非搜尋篩選過的map
          // itemInd為刪除時會傳入的內容
          sortedData._data[data.itemInd].exception = true;
          const mapInd = sortedData._indexMap.indexOf(data.itemInd);
          sortedData._indexMap.splice(mapInd, 1);
        }

        // 雖然是相同的_data與_index資料，但owner 物件為新的，符合pure component需求
        sortedData = new DataListWrapper(sortedData._indexMap, sortedData._data);
        this.props.stateHandler({ states: [dataWrapperStateName, ...extraStates], newValues: [sortedData, ...extraNewValues] });

        // 更新 local cache
        if (localCacheName) {
          // for shallow comparing
          localCacheData = localCacheData.slice();
          this.props.saleSkyStateHandler({ states: localCacheName, newValues: localCacheData });
        }

      },
      onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: "Edit" }) },
      onCopyClick: () => {

        this.setState({
          // set mode
          onCopy: true, onEdit: false, editMode: "Copy",
          onPwdEdit: true,
          // clear itemId
          // itemId: '',
        }, () => {
          document.getElementById(this.customization.defaultFocusField).focus();
        });

      },
      successFuncWrapper: (res) => {
        // 包這一層用來處理共用內容
        this.setState({ dataLoaded: true });

        // 客製內容
        this.customization.loadSuccessCb(res);
      },
      loadItemData: () => {
        const id = this.props.params.itemId;


        if (this.customization.loadApi) {
          custJqAjax({
            type: 'GET',
            ajaxsWip: this.ajaxsWip,
            custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
            url: `/api/${this.customization.loadApi + id}`,
            processData: false,
            contentType: false,
            success: this.handlers.successFuncWrapper
          });
        } else {
          this.handlers.successFuncWrapper();
        }

      },
      rowIndexCheck: passUpdate => {
        // 預防使用者在modal重新整理，導致無selectedRowIndex，造成上一筆下一筆功能異常
        if (this.props.params &&
          this.props.params.itemId &&
          !this.props.selectedRowIndex &&
          this.props.selectedRowIndex !== 0) {

          // 初始狀態的ind和indexMap是一樣的
          let itemId = this.props.params.itemId,
            ind = findIndex(this.props.filteredSortedData._data, { [this.customization.itemApiIdKeyName]: itemId });

          if (!passUpdate) {
            this.props.parentStateHandler({
              states: ['selectedItemId', 'selectedRowIndex'],
              newValues: [itemId, ind]
            });
          }

          return ind;
        }
        return this.props.selectedRowIndex;
      },
      changeItem: () => {
        this.handlers.loadItemData();
      },
      onPreviousClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex - 1),
          rowIndex = r >= 0 ? r : 0;
        if (rowIndex !== selectedRowIndex) {
          // let id = this.props.productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, this.props.filteredSortedData, '', 1);
          // this.handlers.loadItemData(id);

          // load new Product
          this.funcs.resetState(this.handlers.changeItem);
        }
      },
      onNextClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex + 1),
          filteredSortedData = this.props.filteredSortedData,
          max = filteredSortedData.getSize(),
          rowIndex = r < max ? r : (max - 1);
        if (rowIndex !== selectedRowIndex) {
          // let id = productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, filteredSortedData, '', 1);
          // this.handlers.loadItemData(id);

          // load new Product
          this.funcs.resetState(this.handlers.changeItem);
        }
      }
    };

    this.funcs = {
      resetState: cb => {

        this.setState({
          // customized
          ...this.customization.defaultState,
          // common ===
          btnSaveDisable: true,
          btnDeleteDisable: true,
          onEdit: false,
          onCopy: false,
          editMode: "View",
          dataLoaded: false
        }, cb ? cb : "");
      }
    };

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // setTimeout Id
    this.timer = "";

    this.state = {
      // customized
      ...this.customization.defaultState,
      // common ===
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View",
      dataLoaded: false
      // ===
    };
  }

  componentDidMount() {
    // 確保資料ready之後(在modal做重新整理的情況)才帶入modal資料，並只執行1次
    if (this.props.sortedData._data && !this.state.dataLoaded) {

      if (this.props.params && this.props.params.itemId) {
        this.handlers.loadItemData();
      } else {
        document.getElementById(this.customization.defaultFocusField).focus();
        this.setState({ dataLoaded: true });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // 確保資料ready之後才帶入modal資料，並只執行1次
    if (this.props.sortedData._data && !this.state.dataLoaded) {

      if (this.props.params && this.props.params.itemId) {
        this.handlers.loadItemData();
      } else {
        document.getElementById(this.customization.defaultFocusField).focus();
        this.setState({ dataLoaded: true });
      }
    }


    // 資料驗證ok才可送出
    let savable = true;
    for (let i = this.customization.saveBtnValidationKeys.length - 1; i >= 0; i--) {
      const saveBtnValidationKey = this.customization.saveBtnValidationKeys[i],
        stateValue = this.state[saveBtnValidationKey];

      if (stateValue === '' || stateValue === '0') {
        savable = false;
        break;
      }
    }


    if (!savable) {

      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });

    } else if (this.state.btnSaveDisable) {
      this.setState({ btnSaveDisable: false });
    }
  }

  componentWillUnmount() {
    this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
    clearTimeout(this.timer);
  }

  render() {
    const props = this.props,
      state = this.state,
      handlers = this.handlers;

    let saveBtn = "",
      deleteBtn = "",
      editable = 0,
      modeBtns = "",
      itemId = "",
      pagerUd = "",
      saveBtnText = '儲存';

    if (props.params) itemId = props.params.itemId;
    // else  itemId = props.itemId;

    if (state.editMode !== "View" || !itemId) {
      saveBtn = (
        <Button disabled={state.btnSaveDisable}
          onClick={() => { handlers.saveItem(state.onEdit ? 1 : 0) }}
          style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
          {saveBtnText}
        </Button>
      );
      editable = 1;
    } else {
      // let tipText = "";

      modeBtns = (
        <span>
          {
            (
              props.activeAdminItem === 'media-cloud-file-attribute' ||
              props.activeAdminItem === 'repair-status'
            )
              ?
              ""
              :
              <Button
                onClick={handlers.onCopyClick}
                style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
                複製
              </Button>
          }
          <Button
            onClick={handlers.onEditClick}
            style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
            編輯
          </Button>
        </span>
      );

      let disablePreviousBtn = false,
        disableNextBtn = false;

      if (props.filteredSortedData.getSize) {
        const selectedRowIndex = handlers.rowIndexCheck(true),
          max = props.filteredSortedData.getSize();

        disablePreviousBtn = (selectedRowIndex === 0);
        disableNextBtn = (selectedRowIndex === (max - 1));
      }

      pagerUd = <PagerUd style={{ position: "absolute", width: "100%", marginTop: 0, marginBottom: 0, marginLeft: -15, fontSize: 14, padding: "1px 0" }}
        onPreviousClick={handlers.onPreviousClick}
        onNextClick={handlers.onNextClick}
        disablePreviousBtn={disablePreviousBtn}
        disableNextBtn={disableNextBtn} />;
    }

    deleteBtn = (state.onEdit && props.activeAdminItem !== 'media-cloud-file-attribute' && props.activeAdminItem !== 'repair-status') ?
      <DeleteBtnWithConfirm
        style={{ float: "right", marginLeft: 5, position: "relative", zIndex: "3" }}
        onClick={handlers.deleteItem}
        title="Are you sure?" />
      : "";

    return (
      <Modal id="modal-product" keyboard={false} backdrop="static" show={true} onHide={props.closeModal} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              {
                itemId ?
                  <span style={{ float: "left" }}>
                    <span style={{ color: "rgba(0, 0, 200, .7" }}>{state.editMode}</span> Mode
                </span> :
                  <span>
                    New Item
                </span>
              }
            </span>
            <Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
            {saveBtn}
            {modeBtns}
            {deleteBtn}
            {pagerUd}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {
              this.customization.formCompos.map((item, ind) => {
                switch (item.type) {
                  case 'textInput':
                    return (
                      <Col sm={item.sm} key={item.stateName}>
                        <FormGroup controlId={item.stateName}
                          validationState={item.validation ? (state[item.stateName] ? null : 'error') : null}>
                          <ControlLabel style={{ fontWeight: 'bold' }}>{item.required ? <RequiredMark /> : ''}{item.label}</ControlLabel>
                          <FormControl
                            disabled={item.disabled || !editable}
                            type='text'
                            onFocus={item.autoFillEnable ? handlers.onInputFocus : ''}
                            onChange={handlers.textInputOnChange}
                            value={state[item.stateName]}
                            style={{ height: 36 }} />
                        </FormGroup>
                      </Col>
                    );
                  case 'dropDown':
                    // for 檔案屬性值的屬性欄位不可編輯 ===
                    let disabled;
                    if (props.activeAdminItem === 'media-cloud-file-attribute-value') {
                      if (!itemId) {
                        disabled = false;
                      } else {
                        disabled = true;
                      }
                    } else {
                      disabled = !editable;
                    }
                    // ===

                    return (
                      <DropDownMenu
                        key={item.stateName}
                        id={item.id}
                        labelStyle={{ fontWeight: 'bold' }}
                        sm={item.sm}
                        label={item.label}
                        required={item.required}
                        validationState={item.validation ? (state[item.stateName] ? null : 'error') : null}
                        options={props[item.optionsPropsKeyName]}
                        disabled={item.disabled || disabled}
                        onChange={handlers.dropDownOnChange}
                        value={state[item.stateName]}
                        stateName={item.stateName} />
                    );
                  case 'colorPicker':
                    return (
                      <Col sm={item.sm} key={item.stateName}>
                        <FormGroup controlId={item.stateName}
                          validationState={item.validation ? (state[item.stateName] ? null : 'error') : null}>
                          <ControlLabel style={{ fontWeight: 'bold' }}>
                            {item.required ? <RequiredMark /> : ''}{item.label}{item.disabled || !editable ? "" : " (請點擊選擇。)"}
                          </ControlLabel>

                          {
                            item.disabled || !editable ?
                              <FormControl
                                disabled={item.disabled || !editable}
                                type='text'
                                onChange={handlers.textInputOnChange}
                                value={state[item.stateName]}
                                style={{ height: 36 }} />
                              :
                              <ChromePicker
                                color={state[item.stateName]}
                                onChangeComplete={this.customization.custFunc}
                                disableAlpha={true} />
                          }
                        </FormGroup>
                      </Col>
                    );
                  default:
                    return '';
                }
              })
            }

          </Row>
        </Modal.Body>
        <Modal.Footer>
          {pagerUd}
          <Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
          {saveBtn}
          {deleteBtn}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/SimpleModalCt.jsx